import { request } from "../../api/api"

export const signInApi = (data) => {
    return request.post('/user/login/', data)
}

export const forgotPasswordApi = (data) => {
    return request.post('/user/forgetPassword/', data)
}

export const otpVerify = (data) => {
    return request.post('/user/otpVerify/', data)
}

export const newPasswordApi = (data) => {
    return request.post('/user/updatePassword/', data)
}

export const verifyuser = (data) => {
    return request.post('/user/verifyUser/', data)
}
